import { LoaderFunctionArgs, LoaderFunction } from 'react-router-dom'

import { eventsApi } from '../../../services/events'
import type { AppStore } from '../../../store'

export const subEventLoader = (store: AppStore) =>
  (async ({ params, request }: LoaderFunctionArgs) => {
    const url = new URL(request.url)
    const sessionsId = url.searchParams.get('sessionId')?.split(',')
    const { subEventId, eventId } = params
    const skip =
      !eventId || !subEventId || Number.isNaN(Number(eventId)) || Number.isNaN(Number(subEventId))
    if (skip) return { sessions: [], subEvent: undefined }

    const sessions = !sessionsId
      ? []
      : await Promise.all(
          sessionsId.map(async sessionId => {
            const { data: sessionData } = await store.dispatch(
              eventsApi.endpoints.getSession.initiate(
                { eventId: Number(eventId), id: Number(sessionId) },
                { forceRefetch: true }
              )
            )
            return sessionData
          })
        )

    const { data: subEvent } = await store.dispatch(
      eventsApi.endpoints.getSubEvent.initiate(
        { eventId: Number(eventId), id: Number(subEventId) },
        { forceRefetch: true }
      )
    )

    return { sessions: sessions.filter(el => !!el), subEvent }
  }) satisfies LoaderFunction

export const sessionLoader = (store: AppStore) =>
  (async ({ params, request }: LoaderFunctionArgs) => {
    const url = new URL(request.url)
    const subEventIds = url.searchParams.get('subEventIds')?.split(',')
    const { sessionId, eventId } = params
    const skip =
      !eventId || !sessionId || Number.isNaN(Number(eventId)) || Number.isNaN(Number(sessionId))
    if (skip) return { session: undefined, subEvents: [] }

    const { data: session } = await store.dispatch(
      eventsApi.endpoints.getSession.initiate(
        { eventId: Number(eventId), id: Number(sessionId) },
        { forceRefetch: true }
      )
    )

    const subEvents = !subEventIds
      ? []
      : await Promise.all(
          subEventIds.map(async subEvent => {
            if (subEvent === '' || Number.isNaN(Number(subEvent))) return undefined
            const { data: subEventData } = await store.dispatch(
              eventsApi.endpoints.getSubEvent.initiate(
                { eventId: Number(eventId), id: Number(subEvent) },
                { forceRefetch: true }
              )
            )
            return subEventData
          })
        )

    return { session, subEvents: subEvents.filter(el => !!el) }
  }) satisfies LoaderFunction
